import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const PayPeriodSelector = ({ period, onChange, testId = "pay-period-selector" }) => {
  if (!period) return null;
  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <button
        className="p-1.5 rounded-md hover:bg-summit-glacier"
        onClick={() => onChange(period.period_number - 1)}
        aria-label="Previous period"
        data-testid="period-prev"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>
      <div className="px-3 py-1.5 border border-summit-hairline rounded-md bg-white min-w-0 md:min-w-[260px] text-center max-w-full truncate">
        <div className="font-mono text-[10px] uppercase tracking-widest text-gray-500">
          Pay Period {period.period_number}
        </div>
        <div className="text-sm font-medium">{period.range_label}</div>
      </div>
      <button
        className="p-1.5 rounded-md hover:bg-summit-glacier"
        onClick={() => onChange(period.period_number + 1)}
        aria-label="Next period"
        data-testid="period-next"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
};
